import { config as aboutYouConfig } from './about-you.config';
import { config as completeConfig } from './complete-page.config';
import { config as pathConfig } from './path.config';
import { config as remoteConfig } from './remote.config';
import { config as modeConfig } from './mode.config';
import { config as selectDateConfig } from './select-date.config';
import { config as reviewConfig } from './review.config';
import { EDIT_PROGRESS_BAR_ITEMS, PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { ChosenPartnerDropdown } from '~/components';
import { getAppointmentsDetails } from './analytics.config';
import { createHeadline } from './headline.config';
import { services } from '../../services.constant';

const questionsSectionsConfig = [
  {
    key: undefined,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
  },
];

export const config = {
  ...aboutYouConfig,
  ...completeConfig,
  ...pathConfig,
  ...selectDateConfig,
  ...reviewConfig,
  serviceName: services.NURSERY.name,
  remote: remoteConfig,
  mode: modeConfig,
  PROGRESS_BAR_ITEMS,
  EDIT_PROGRESS_BAR_ITEMS,
  chosenPartner: ChosenPartnerDropdown,
  partnerTitle: 'Nursery Advisor',
  getAppointmentsDetails,
  isPartnerSelectionEnabled: true,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
};
